import { sortBy } from "@s-libs/micro-dash";
import PropTypes from "prop-types";

import getLevelDisplayValues from "@/assignments/utils/getLevelDisplayValues";
import SelectedStateIndicator from "@/components/SelectedStateIndicator";
import { NUMERICAL_GRADE_BANDS } from "@/constants/GradeAndLexileLevels";
import { LANG_TOGGLE_LIST } from "@/constants/Language";
import ActionsDropdown from "@/view/ActionsDropdown";
import LevelItem from "../LevelItem";
import { itemCss } from "./LevelDropdownItems.style";

const propTypes = {
  defaultReadingLevel: PropTypes.number,
  eventProperties: PropTypes.object,
  language: PropTypes.oneOf(LANG_TOGGLE_LIST),
  levels: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      grade_band: PropTypes.string,
    }),
  ),
  onClick: PropTypes.func,
};

const LevelDropdownItems = ({
  defaultReadingLevel,
  eventProperties,
  language,
  levels,
  onClick,
}) => {
  const levelsFilteredByLanguage = levels.filter(
    (level) => level.language === language,
  );
  const sortedLevels = sortBy(
    levelsFilteredByLanguage,
    ({ grade_band: gradeBand }) => {
      const numericGrade = NUMERICAL_GRADE_BANDS[gradeBand];
      return numericGrade;
    },
  ).reverse();

  // null captures the 'Newsela recommended' state.
  return [null, ...sortedLevels].map((level, index) => {
    const numericGrade = NUMERICAL_GRADE_BANDS[level?.grade_band] || null;
    const isSelected = defaultReadingLevel === numericGrade;

    const itemEventProperties = {
      ...eventProperties,
      streamProperties: {
        ...eventProperties.streamProperties,
        description: `Change article level to ${numericGrade || "Newsela recommended"}.`,
      },
    };

    const { formattedGrade, lexileRange } = getLevelDisplayValues(level);
    const formattedLexileRange = lexileRange?.replace("-", "to");
    const ariaLabel = numericGrade
      ? `${formattedGrade}, ${formattedLexileRange}`
      : "Newsela recommended";

    return (
      <ActionsDropdown.ButtonItem
        key={level?.grade_band || "newsela-recommended"}
        __cssFor={{ Button: { root: itemCss } }}
        ariaProps={{ "aria-current": isSelected, "aria-label": ariaLabel }}
        dataProps={{
          "data-qa-selector": `assignment-level-selector-item-${index}`,
        }}
        eventProperties={itemEventProperties}
        isSelected={isSelected}
        onClick={() => onClick(level, numericGrade)}
      >
        <SelectedStateIndicator shouldDisplay={isSelected} />
        <LevelItem level={level} />
      </ActionsDropdown.ButtonItem>
    );
  });
};

LevelDropdownItems.propTypes = propTypes;

export default LevelDropdownItems;
